export class Haptics {
    constructor(enabled) {
        Object.defineProperty(this, "enabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: enabled
        });
    }
    setEnabled(on) {
        this.enabled = on;
    }
    hit(precision) {
        if (!this.enabled || !("vibrate" in navigator))
            return;
        navigator.vibrate(Math.round(8 + precision * 22));
    }
    combo() {
        if (!this.enabled || !("vibrate" in navigator))
            return;
        navigator.vibrate([12, 20, 12]);
    }
}
